import { useEffect, useRef } from "react";

/* Drive a per-frame callback off requestAnimationFrame.
 * onTick is captured via a ref so the rAF loop never restarts on every render. */
export function useEngineAnimationLoop(onTick) {
  const onTickRef = useRef(onTick);
  useEffect(() => { onTickRef.current = onTick; }, [onTick]);

  useEffect(() => {
    let raf;
    const tick = () => {
      onTickRef.current();
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);
}
